import moment from "moment-timezone";
import { Day } from "types/code-generator";
import { days } from "./constants";

export const sortByDayAndTime = (
  classTimes: {
    allDayPresentation: string;
    day: Day;
    date: Date;
    endTime: string;
    location: {
      id: string;
    };
    zone: {
      id: string;
    };
    startTime: string;
  }[] = []
) => {
  return [...classTimes].sort((a, b) => {
    const classTimeAStartTime = moment(a.startTime, "HH:mm");
    const classTimeBStartTime = moment(b.startTime, "HH:mm");

    let classTimeA = moment().set({
      day: days.findIndex((d) => d.value === a.day),
      hour: classTimeAStartTime.get("hour"),
      minute: classTimeAStartTime.get("minute"),
    });

    let classTimeB = moment().set({
      day: days.findIndex((d) => d.value === b.day),
      hour: classTimeBStartTime.get("hour"),
      minute: classTimeBStartTime.get("minute"),
    });

    if (a.date) {
      classTimeA = moment(a.date);
    }

    if (b.date) {
      classTimeB = moment(b.date);
    }

    return classTimeA.unix() - classTimeB.unix();
  });
};
